module.exports = __webpack_public_path__ + "img/minnie.1b87f928.png";